<template>
  <div class="edit-metadata pa-3 mb-4">
    <div class="edit-metadata__row d-flex flex-wrap">
      <div class="edit-metadata__item mr-6 mb-2 d-flex flex-wrap align-center">
        <span class="font-weight-medium mr-2">
          {{ $t('entities.users.entity') }}:
        </span>
        <span>{{ userLabel }}</span>
      </div>
      <div class="edit-metadata__item mb-2 d-flex flex-wrap align-center">
        <span class="font-weight-medium mr-2">
          {{ $t('miscellaneous.date') }}:
        </span>
        <span>{{ formattedCreatedAt }}</span>
      </div>
    </div>
    <div class="edit-metadata__row">
      <div class="edit-metadata__values">
        <span class="font-weight-medium mr-2">
          {{ $t('entities.stockTransactions.availableStockBefore') }}:
        </span>
        <span>{{ availableStockMetadata.beforeValue }}</span>
        <span class="mx-2 grey--text text--darken-1">→</span>
        <span class="font-weight-medium mr-2">
          {{ $t('entities.stockTransactions.availableStockAfter') }}:
        </span>
        <span>{{ availableStockMetadata.afterValue }}</span>
      </div>
    </div>
    <div v-if="shouldDisplayWasteStockRows" class="edit-metadata__row">
      <div class="edit-metadata__values">
        <span class="font-weight-medium mr-2">
          {{ $t('entities.stockTransactions.wasteStockBefore') }}:
        </span>
        <span>{{ wasteStockMetadata.beforeValue }}</span>
        <span class="mx-2 grey--text text--darken-1">→</span>
        <span class="font-weight-medium mr-2">
          {{ $t('entities.stockTransactions.wasteStockAfter') }}:
        </span>
        <span>{{ wasteStockMetadata.afterValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionMetadataBox',
  props: {
    transaction: { type: Object, default: () => ({}) },
    users: { type: Array, default: () => [] },
    wasteCodes: { type: Array, default: () => [] },
  },
  computed: {
    availableStockMetadata() {
      return {
        beforeValue: this.transaction?.available_stock_before,
        afterValue: this.transaction?.available_stock_after,
      }
    },
    formattedCreatedAt() {
      const rawCreatedAt = this.transaction?.created_at
      const createdAt = new Date(rawCreatedAt)
      return createdAt.toLocaleString()
    },
    shouldDisplayWasteStockRows() {
      const transactionType = this.transaction?.type?.code
      return this.wasteCodes?.includes(transactionType)
    },
    userLabel() {
      const userId = this.transaction?.user_id
      if (!userId || !Array.isArray(this.users)) return '-'
      const user = this.users.find((it) => it?.id === userId)
      return user?.username || '-'
    },
    wasteStockMetadata() {
      return {
        beforeValue: this.transaction?.waste_stock_before,
        afterValue: this.transaction?.waste_stock_after,
      }
    },
  },
}
</script>

<style>
.edit-metadata {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.edit-metadata__row {
  margin-bottom: 8px;
}

.edit-metadata__row:last-child {
  margin-bottom: 0;
}

.edit-metadata__values {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 500;
}
</style>
